var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AlternativeDetailsDialog", {
        attrs: { viewModel: _vm.alternativeDetailsDialog },
      }),
      _vm._v(" "),
      _c("AttributeDescriptionDialog", {
        attrs: { viewModel: _vm.attributeDescriptionDialog },
      }),
      _vm._v(" "),
      !_vm.Initialized || _vm.Connecting
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-center",
              staticStyle: { "padding-top": "200px" },
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.Initialized && !_vm.Connecting && !_vm.MeetingStarted
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-center",
              staticStyle: { "padding-top": "200px" },
            },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title" }, [
                    _vm._v("Meeting is not started"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text lead" }, [
                    _vm._v("Please wait for the host to start this meeting."),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.DashboardUrl,
                          expression: "DashboardUrl",
                        },
                      ],
                      staticClass: "btn btn-secondary",
                    },
                    [_vm._v("Go to the survey mode")]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.Initialized &&
      !_vm.Connecting &&
      _vm.MeetingStarted &&
      _vm.EligibleQuestion
        ? _c("div", [
            _c(
              "nav",
              {
                staticClass:
                  "navbar navbar-expand-md navbar-dark bg-dark fixed-top",
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.DashboardUrl,
                          expression: "DashboardUrl",
                        },
                      ],
                      staticClass: "btn btn-light mr-auto",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-angle-double-left",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                    My Survey\n                "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: { "padding-top": "80px" },
              },
              [
                _c("div", { attrs: { id: "MeetingQuestion" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "min-height": "100vh",
                        "margin-top": "80px",
                      },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "text-center lead",
                          staticStyle: { "font-size": "1.5rem" },
                        },
                        [
                          _vm._v(
                            "\n                        How would you rate: "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary",
                              attrs: { title: "Show description" },
                              on: { click: _vm.ShowAlternativeDetailsCommand },
                            },
                            [_vm._v(_vm._s(_vm.AlternativeName))]
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                        in the context of: "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary",
                              attrs: { title: "Show description" },
                              on: { click: _vm.ShowAttributeDetailsCommand },
                            },
                            [_vm._v(_vm._s(_vm.AttributeName))]
                          ),
                          _vm._v("?\n                    "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "min-height": "450px" } },
                        [
                          _c("PanelistVoteEditor", {
                            attrs: {
                              comment: _vm.voteComment,
                              value: _vm.voteValue,
                              scaleLevels: _vm.Question.ScaleLevels,
                            },
                            on: {
                              "update-comment": _vm.handleUpdateComment,
                              "update-value": _vm.handleUpdateValue,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.Question?.Entries != null
                        ? _c(
                            "div",
                            {
                              staticClass: "mt-4",
                              staticStyle: { "min-height": "500px" },
                            },
                            [
                              _c("VotesBrowser", {
                                attrs: {
                                  AlternativeName: _vm.Question.AlternativeName,
                                  HasScale: _vm.Question.HasScale,
                                  Entries: _vm.Question.Entries,
                                  ScaleLevels: _vm.Question.ScaleLevels,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.Initialized &&
      !_vm.Connecting &&
      _vm.MeetingStarted &&
      !_vm.EligibleQuestion
        ? _c("div", [
            _c(
              "nav",
              {
                staticClass:
                  "navbar navbar-expand-md navbar-dark bg-dark fixed-top",
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.DashboardUrl,
                          expression: "DashboardUrl",
                        },
                      ],
                      staticClass: "btn btn-light mr-auto",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-angle-double-left",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                    My Survey\n                "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("h5", { staticClass: "card-title" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
          _vm._v(" Connecting..."),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "card-text lead" }, [
          _vm._v("We are checking if meeting was started by the host."),
        ]),
        _c("br"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "container", staticStyle: { "padding-top": "80px" } },
      [
        _c("div", { attrs: { id: "MeetingQuestion" } }, [
          _c(
            "div",
            { staticStyle: { "min-height": "100vh", "margin-top": "80px" } },
            [
              _c("div", { staticClass: "d-flex justify-content-center" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v(
                        "Sorry, you are not selected to answer this question."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text lead" }, [
                      _vm._v("Please wait for another question."),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v("\n                iv\n            "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }